import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JointJsCanvasComponent } from './jointjscanvas.component';
import { Dialog } from 'primeng/dialog';
import { FormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { Editor } from 'primeng/editor';
@NgModule({
    declarations: [JointJsCanvasComponent],
    imports: [CommonModule, Dialog, FormsModule, DragDropModule, Editor],
    exports: [JointJsCanvasComponent]
})

export class JointJsCanvasModule { }
